import { useCallback, useContext } from 'react';
import { useMutation } from '@tanstack/react-query';
import type { Chat } from '@trinity/chat';
import { ChatSessionQueriesContext } from '@trinity/chat-components/components/Chat/context';
import { ChatStateDispatchContext } from '@trinity/chat-components/components/Chat.State/context';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient';

type Props = {
  chatInstanceId: number;
  queryIdentifier: string;
};

export const useUpdateQueryRatingMutation = ({ chatInstanceId, queryIdentifier }: Props) => {

  const sessionQueries = useContext(ChatSessionQueriesContext);
  const dispatch = useContext(ChatStateDispatchContext);

  const dispatchRating = useCallback((rating: Chat.Rating) => {
    dispatch({
      type: 'query-rated',
      payload: {
        queryIdentifier,
        rating,
      },
    });
  }, [dispatch, queryIdentifier]);

  const apiClient = useChatApiClient();

  return useMutation({
    mutationKey: ['query:patch:rating'],

    mutationFn: (rating: Chat.Rating) => {
      return apiClient.queries.updateQueryRating({
        chatInstanceId,
        queryIdentifier,
        rating,
      });
    },

    onMutate: rating => {
      const query = sessionQueries[queryIdentifier];
      dispatchRating(rating);
      return { oldRating: query.rating };
    },

    onError: (_res, _variables, context) => {
      dispatchRating(context.oldRating);
    },

    onSuccess: res => {
      dispatchRating(res.query.rating);
    },
  });
};